import { Component } from '@angular/core';
import { ErrorService } from '@services/error.service';
import { MsLoginServiceService } from '../../../modules/login/service/ms-login-service.service';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss']
})
export class ServerErrorComponent {
  errMsg;
  errSubMsg;
  showRefresh;
  showLogout;
  constructor(private errSr: ErrorService, private msLoginService: MsLoginServiceService, ){
    this.errMsg = errSr.errMsg
    this.errSubMsg = errSr.errSubMsg
    this.showRefresh = errSr.showRefresh
    this.showLogout = errSr.showLogout
  }

  refreshApp(){
    window.location.reload()
  }

  logout() {
    this.msLoginService.logoutSSO();
  }
}
